import './back-to-top.scss';
import { TweenMax, Circ, Elastic } from 'gsap';

const BackToTopComponent = {
  el: null,

  init() {
    this.el = document.querySelector('#back-to-top');

    window.addEventListener('scroll', this.checkToShow.bind(this));

    this.el.addEventListener('click', this.goToTop.bind(this));
  },

  goToTop() {
    if(window.innerWidth>768){
      TweenMax.to(window, 1, { scrollTo: 0 });
    }else{
      TweenMax.set(window,{ scrollTo: 0 });
    }
    
  },

  checkToShow() {
    let doc = document.documentElement;
    let scrollTop = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
    let windowHeight = window.outerHeight;

    if (scrollTop > windowHeight * .5) {
      this.el.style.display = 'block';
      TweenMax.to(this.el, .5, { top: '40%', alpha: 1, ease: Circ.easeOut });
    } else {
      TweenMax.to(this.el, .5, { top: '35%', alpha: 0, ease: Circ.easeIn, onComplete: () => {
        this.el.style.display = 'none';
      }});
    }
  }
};

export default BackToTopComponent;